'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropFromDefaultName = exports.getOnChangeName = exports.getDefaultPropName = undefined;

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param  {string}
 * @return {string}
 */
var capitalize = function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
};

/**
 * @param  {string}
 * @return {string}
 */
var uncapitalize = function uncapitalize(str) {
  return str[0].toLowerCase() + str.slice(1);
};

/**
 * @param  {string}
 * @return {string}
 */
var getDefaultPropName = exports.getDefaultPropName = (0, _memoize2.default)(function (field) {
  return 'default' + capitalize(field);
});

/**
 * @param  {string}
 * @return {string}
 */
var getOnChangeName = exports.getOnChangeName = (0, _memoize2.default)(function (field) {
  if (field === 'value') {
    return 'onChange';
  }
  return 'on' + capitalize(field) + 'Change';
});

/**
 * @param  {string}
 * @return {string}
 */
var getPropFromDefaultName = exports.getPropFromDefaultName = (0, _memoize2.default)(function (defaultProp) {
  if (!defaultProp) {
    return '';
  }

  return uncapitalize(defaultProp.replace('default', ''));
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/core/PropNames.js
// module id = 481
// module chunks = 177